import Router from 'components/routes/routers/contract/managementAct/ManagementActContractRouter';
import Creation, { formValidate } from './Creation';

const managementAct = {
    label: 'Acte de gestion',
    icon: 'line-chart',
    isAvailable: () => true,
    formComponent: Creation,
    formValidation: (errors, values, props) => formValidate(values, props, errors),
    router: Router,
};

export default managementAct;
